import { render, staticRenderFns } from "./TabMenu.vue?vue&type=template&id=4cfff1d2"
import script from "./TabMenu.vue?vue&type=script&lang=js"
export * from "./TabMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports